// extracted by mini-css-extract-plugin
export default {"main-page":"main-page_main-page__XhETa"};